import request from '@/utils/request'

// 获取字典数据
export function getDictData(params) {
  return request({
    url: '/system/dict/data/list',
    method: 'get',
    params
  })
}